// src/LanguageSelector.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../Style/LanguageSelector.css'; // Crée un fichier CSS pour le style

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'fr-CH', name: 'Français Suisse', flag: '🇨🇭' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de-CH', name: 'Deutsch Schweiz', flag: '🇨🇭' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  useEffect(() => {
    const current = i18n.resolvedLanguage || i18n.language;
    document.documentElement.dir = current === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = current;
  }, [i18n.language, i18n.resolvedLanguage]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedLang(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  };

  return (
    <div className="language-selector">
      <div className="selected-language">
        <span>{languages.find((lang) => lang.code === selectedLang)?.flag}</span>
        <select
          value={selectedLang}
          onChange={(e) => changeLanguage(e.target.value)}
          className="language-dropdown"
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.flag} {lang.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default LanguageSelector;
